// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vv_a bhc_b bhc_ux"};